"use client"

import SignIn from "@/components/SignIn"
import {
  useSignInPage
} from "@/hooks/SignInPage/useSignInPage"
import {
  BrowserPersistence
} from "@/util"
import clsx from "clsx"
import {
  useEffect 
} from "react"
import {
  FormattedMessage
} from "react-intl"

const storage = new BrowserPersistence()

const SignInPage = (props) => {
  const {
    signInProps 
  } = useSignInPage({
    ...props,
    signedInRedirectUrl: storage.getItem("redirect") || "/my-account"
  })
  const {
    showCreateAccount 
  } = signInProps

  useEffect(() => {
    return () => {
      storage.removeItem("redirect")
    }
  }, [])

  return (
    <div
      className={clsx(
        " px-4 pb-[77px] pt-11 lg_px-0 lg_pb-[210px] lg_pt-[59px]",
        "mx-auto max-w-[760px]"
      )}
    >
      <div className='border-b-1 border-E7DED5 flex items-center border-solid'>
        <h1
          className={clsx(
            "flex-1 text-center font-Shango text-[22px] leading-[26px]",
            "relative cursor-pointer pb-2.5",
            'after_absolute after_bottom-0 after_left-0 after_h-0.5 after_w-full after_bg-80583F after_content-[""]'
          )}
        >
          <FormattedMessage id='signInPage.logintitle' defaultMessage='LOGIN' />
        </h1>
        <h1
          className={clsx(
            "flex-1 text-center font-Shango text-[22px] leading-[26px]",
            " cursor-pointer pb-2.5"
          )}
          onClick={showCreateAccount}
        >
          <FormattedMessage
            id='signInPage.registertitle'
            defaultMessage='REGISTER'
          />
        </h1>
      </div>
      <div className='lg_mt-8 mx-auto mt-11 max-w-[540px]'>
        <SignIn {...signInProps} />
      </div>
    </div>
  )
}

export default SignInPage
